import { PKG_SEARCH_SESSION_RECOVERY_KEY } from '@/constants/pkg-search-recovery'

/** SETI: when `containsXSell` is true on the recovery payload, only persist restore/redirect in VARIANT. */
export const PKG_XSELL_ERROR_PERSIST_SEARCH_CRITERIA_SETI = 'PKG_XSELL_ERROR_PERSIST_SEARCH_CRITERIA'

export type PkgSessionRecoveryPayload = {
  isAdvancedSearch?: boolean
  containsXSell?: boolean
  tripsSearchForm?: Record<string, unknown>
}

export function readPkgSessionRecoveryFromStorage(): PkgSessionRecoveryPayload | null {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    const raw = sessionStorage.getItem(PKG_SEARCH_SESSION_RECOVERY_KEY)
    if (!raw) {
      return null
    }
    const parsed = JSON.parse(raw) as PkgSessionRecoveryPayload
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : null
  } catch {
    return null
  }
}

/** Non–xsell recovery is always allowed; xsell persistence/restores require PKG_XSELL_ERROR_PERSIST_SEARCH_CRITERIA === VARIANT and containsXSell === true. */
export function shouldApplyPkgRecoveryForXsell(
  payload: PkgSessionRecoveryPayload | null,
  seti: Record<string, string> | undefined,
): boolean {
  if (payload?.containsXSell !== true) {
    return true
  }
  return seti?.[PKG_XSELL_ERROR_PERSIST_SEARCH_CRITERIA_SETI] === 'VARIANT'
}
